module.exports = __webpack_public_path__ + "static/media/IMG_6328.f0d44038.JPG";